export const commentTopics = {
    TOPIC_INSPECTION_REPORTS: 1,
    TOPIC_OBSERVATIONS: 2,
    TOPIC_WORK_ASSIGNMENT: 3,
    TOPIC_ORDERS: 4,
    TOPIC_DANGER_REPORTS: 5,
    TOPIC_MVR_INSPECTION: 6,
}
